import gql from 'graphql-tag';

export const GENERATE_CALL_JOIN_PARAMS = gql`
  mutation ($conversationId: Int!, $deviceId: String!, $instanceId: String!) {
    generateCallJoinParams (input: {conversationId: $conversationId, deviceId: $deviceId, instanceId: $instanceId}) {
      deviceId
      instanceId
      jwtRegister
      userId
      applicationId
      mediaGatewayUrl
      mode
    }
  }
`;
